import styled, { css } from 'styled-components';

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 21px;
  min-width: 16px;

  ${({ hasChildren }) =>
    hasChildren &&
    css`
      margin-right: var(--xs-padding-horizontal);
    `}
`;
